import {
    validateEmail,
    validatePostalCode,
    validateFirstName,
    validateLastName,
    validateAddress
} from '../Shared/validations.js';

const validate = values => {
    const errors = {
        ...validateFirstName(values),
        ...validateLastName(values),
        ...validatePostalCode(values),
        ...validateAddress(values),
        ...validateEmail(values)
    };

    return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/components/ElectionReminder/validations.js